// loader.service.ts
import { Injectable, ApplicationRef, ComponentFactoryResolver, Injector, EmbeddedViewRef, ComponentRef } from '@angular/core';
// import { LoaderComponent } from './path-to-your-custom-loader/custom-loader.component';
import { LoaderComponent } from '../components/loader/loader.component';

@Injectable({
  providedIn: 'root'
})
export class LoaderService {
  private loaderComponentRef: ComponentRef<LoaderComponent> | undefined;

  constructor(
    private componentFactoryResolver: ComponentFactoryResolver,
    private appRef: ApplicationRef,
    private injector: Injector
  ) {}

  showLoader(message?: string): void {
    // Create component reference
    const factory = this.componentFactoryResolver.resolveComponentFactory(LoaderComponent);
    this.loaderComponentRef = factory.create(this.injector);

    // Set message if provided
    if (message) {
      // this.loaderComponentRef.instance.message = message;
    }

    // Attach the component to the application view
    this.appRef.attachView(this.loaderComponentRef.hostView);

    // Append the component to the body
    const domElem = (this.loaderComponentRef.hostView as EmbeddedViewRef<any>).rootNodes[0] as HTMLElement;
    document.body.appendChild(domElem);
  }

  hideLoader(): void {
    if (this.loaderComponentRef) {
      // Detach the component from the application view
      this.appRef.detachView(this.loaderComponentRef.hostView);

      // Remove the component from the body
      this.loaderComponentRef.destroy();
      this.loaderComponentRef = undefined;
    }
  }
}